import { Field } from "src/matrixTableNode/MatrixTableNodeEditor";

export const Fallback = ({
  errorMessage,
  readOnly,
  searchHighlightKey,
}: {
  errorMessage: string | undefined;
  readOnly: boolean;
  searchHighlightKey?: string;
}) => {
  return (
    <div className="mb-4 flex">
      <div className="flex h-8 w-28 items-center bg-gray-50">
        <p className="pl-1 font-inter-medium-11px text-gray-500">is any</p>
      </div>
      <div className="flex-1">
        <Field
          errorMessage={errorMessage}
          name="fallback.value"
          readOnly={readOnly}
          searchHighlightKey={searchHighlightKey}
          variant="cell-expandable"
          result
        />
      </div>
    </div>
  );
};
